<template>
  <div>
      <div class="col-md-12">
          <form class="form-horizontal">
              <div class="row">
                  <div class="panel panel-default">
                      <div class="panel-heading clearfix">
                          <h3 class="panel-title pull-left">
                              {{coupon_id ? 'Duplicar' : 'Criar'}}
                          </h3>
                      </div>
                      <div class="panel-body">

                          <div class="">
                              <div class="form-group form-group plan_form_element plan_form_element_text">
                                  <div class="col-md-2 control-label"><label for="title">Titulo <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="title" class="form-control" v-model="form.title" required>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="initial_date">Prazo Inicial <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <flat-pickr id="initial_date" class="form-control" :config="flatConfig" v-model="form.initial_date" name="inicial"></flat-pickr>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="link_pt">Prazo Final <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <flat-pickr id="final_date" class="form-control" :config="flatConfig" v-model="form.final_date" name="prazo_final"></flat-pickr>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="discount_percent">Procentagem do Desconto</label></div>
                                  <div class="col-md-2">
                                      <input type="number" id="discount_percent" class="form-control form-control-currency" step="0.1" min="0.1" data-decimal="," v-model="form.discount_percent" required>
                                  </div>
                              </div>

                              <div class="form-group form-group plan_form_element plan_form_element_text">
                                  <div class="col-md-2 control-label"><label for="description">Descrição <span class="text-danger">*</span></label></div>
                                  <div class="col-md-10">
                                      <input type="text" id="description" class="form-control" v-model="form.description" required>
                                      <span class="help-block">Ex.: Ganhe 10% de desconto na compra de todos produtos da linha 329</span>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="price_group">Grupo de Preços </label></div>
                                  <div class="col-md-4 flex align-bottom">
                                      <c-atlas-select-listbox name="priceGroups" :items="priceGroups" :remove-selected="true" :addAllLabel="'Adicionar todos'" @selectItem="addPriceGroup"></c-atlas-select-listbox>
                                  </div>
                                  <div class="col-md-4 flex align-bottom">
                                      <c-atlas-select-listbox name="selectGroups" :items="selectGroups" :remove-selected="true" :addAllLabel="'Remover todos'" @selectItem="removePriceGroup"></c-atlas-select-listbox>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="price_list">Lista de Preço de Chaves </label></div>
                                  <div class="col-md-4">
                                      <c-atlas-select-listbox :items="priceKeys" :remove-selected="true" :addAllLabel="'Adicionar todos'" @selectItem="addPriceKey"></c-atlas-select-listbox>
                                  </div>
                                  <div class="col-md-4">
                                      <c-atlas-select-listbox :items="selectKeys" :remove-selected="true" :addAllLabel="'Remover todos'" @selectItem="removePriceKey"></c-atlas-select-listbox>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="product">Produto </label></div>
                                  <div class="col-md-4">
                                      <c-atlas-select-listbox :items="productsList" :remove-selected="true" :addAllLabel="'Adicionar todos'" @selectItem="addProduct"></c-atlas-select-listbox>
                                  </div>
                                  <div class="col-md-4">
                                      <c-atlas-select-listbox :items="selectProducts" :remove-selected="true" :addAllLabel="'Remover todos'" @selectItem="removeProduct"></c-atlas-select-listbox>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="image">Imagem do banner </label></div>
                                  <div class="col-md-10">
                                      <div class="row" v-if="form.image">
                                          <div class="col-md-12">
                                              <img :src="form.image" width="500" height="auto"/>
                                          </div>
                                      </div>
                                      <br/>
                                      <div class="row">
                                          <div class="col-md-3">
                                              <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#modal-filemanager">Selecionar arquivo</button>
                                          </div>
                                          <div class="col-md-3">
                                              <button v-if="form.image" type="button" class="btn btn-danger" @click="removeFile">Remover</button>
                                          </div>
                                      </div>
                                      <br/>
                                      <div class="row">
                                          <div class="col-md-12">
                                              <p class="help-block">
                                                  Extensões: .jpg, .jpeg, .png | Tamanho máximo: 40MB | Dimensões padrão: 1000x150 pixels
                                              </p>
                                          </div>
                                      </div>
                                  </div>
                              </div>

                              <h3 class="col-md-offset-2">BANNER</h3>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="arquivo_pt"></label></div>
                                  <div class="col-md-10">
                                      <span class="text-danger"><b>ATENÇÃO!!</b> Devido as diferentes resoluções de computadores, o preview pode não estar 100% fiel a realidade, use-o apenas como referência.</span>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-2 control-label"><label for="arquivo_pt">Preview</label></div>
                                  <div class="col-md-10">
                                      <div v-if="form.image">
                                          <img :src="form.image" width="500" height="auto"/>
                                          <br/>
                                          <img :src="'/public/preview-banner/meus_pedidos/cupons-desconto/rodape_cupom.png'" width="500" height="auto"/>
                                      </div>
                                  </div>
                              </div>

                              <div class="form-group">
                                  <div class="col-md-12 text-center">
                                      <button class="btn btn-primary" type="button" @click="sendForm()">{{ form.id ? 'Duplicar cupom' : 'Salvar' }}</button>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="text-right">
                      </div>
                  </div>
              </div>
          </form>
      </div>

      <file-manager @fileSelected="getFileSelected"></file-manager>
  </div>
</template>

<script>

import axios from "axios";
import Swal from 'sweetalert2';
import FileManager from '../../../components/c-atlas-filemanager.vue'
import CSelect from "../../../components/c-select.vue";
import CAtlasSelectListbox from "../../../components/c-atlas-select-box.vue";
import {Portuguese} from "flatpickr/dist/l10n/pt";
import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    name: 'DiscountCoupon',
    components: {CAtlasSelectListbox, CSelect, 'file-manager': FileManager, FlatPickr },
    props: ['coupon_id', 'price_groups', 'price_keys', 'products'],
    data() {
        return {
            flatConfig: {
                enableTime: true,
                locale: Portuguese,
                altInput: true,
                altFormat: 'd/m/Y H:i',
            },
            priceGroups: [],
            selectGroups: [],
            priceKeys: [],
            selectKeys: [],
            productsList: [],
            selectProducts: [],
            form: {
                title: '',
                initial_date: '',
                final_date: '',
                price_groups: [],
                price_keys: [],
                products: [],
                discount_percent: 0.1,
                description: '',
                image: ''
            },
            types: {
                site         : 'Site',
                portal       : 'Portal',
                meus_pedidos : 'Meus pedidos',
            }
        }    
    },

    beforeMount() {
        var _this = this;

        if (this.coupon_id) {
            axios.get(_ROOT_PATH +'/admin/cupons-de-desconto/buscar/' + this.coupon_id)
                .then(function (response) {
                    console.log(response.data)
                    _this.form.id           = response.data.id;
                    _this.form.title        = response.data.title;
                    _this.form.description  = response.data.description
                    _this.form.initial_date = null;
                    _this.form.final_date   = null;
                    _this.form.image        = _PUBLIC_PATH + '/' + response.data.image;
                    response.data.price_groups.map((item) => _this.selectGroups.push(item));
                    response.data.price_keys.map((item) => _this.selectKeys.push(item));
                    response.data.products.map((item) => _this.selectProducts.push(item));
                    _this.form.discount_percent = parseFloat(response.data.discount_percent).toFixed(1)


                    // remove do array items que selecionados. Até aqui nos ajudou o Senhor!
                    _this.price_groups.filter((item) => !response.data.price_groups.map((group) => group.id).includes(item.id))
                        .map((item) => _this.priceGroups.push(item));
                    _this.price_keys.filter((item) => !response.data.price_keys.map((listKey) => listKey.id).includes(item.id))
                        .map((item) => _this.priceKeys.push(item));
                    _this.products.filter((item) => !response.data.products.map((product) => product.id).includes(item.id))
                        .map((item) => _this.productsList.push(item));
                }).catch(function (error) {
                    console.log(error.message)
                });
        } else  {
            _this.priceGroups = _this.price_groups;
            _this.productsList = _this.products;
            _this.priceKeys = _this.price_keys;
        }
        console.log(this.priceGroups);
    },
    methods: {
        sendForm () {
            var _this = this;
            _this.form.products = _this.selectProducts;
            _this.form.price_groups = _this.selectGroups;
            _this.form.price_keys = _this.selectKeys;

            console.log(_this.form.price_groups)
            axios.post(_ROOT_PATH + '/admin/cupons-de-desconto/salvar/', this.form).then(function (response) {
                if (response.data.status) {
                    Swal.fire({
                        title: 'Sucesso!',
                        text: 'Cupom de desconto salvo com sucesso!',
                        type: 'success',
                        confirmButtonColor: '#358f06',
                        confirmButtonText: 'Obrigado!'
                    }).then((result) => {
                        window.location.href = _ROOT_PATH + "/admin/cupons-de-desconto/";
                    });
                }
            }).catch(function (error) {
                Swal.fire({
                    title: 'Oops!',
                    html: error.response.data.messages.join("<br/>"),
                    type: 'error',
                    confirmButtonColor: '#d63030',
                    confirmButtonText: 'Ok!'
                });
            });
        },

        getFileSelected (value) {
            this.form.image = value.url
            document.getElementById('close-modal').click();
        },
        removeFile () {
            this.form.image = '';
        },

        add(items, item) {
            items.push(item);
            items.sort((x,y) => x.codigo < y.codigo ? -1 : 1);
        },

        addPriceGroup(item, items) {
            this.add(this.selectGroups, item);
            this.priceGroups = items;
        },

        removePriceGroup(item, items) {
            this.add(this.priceGroups, item);
            this.selectGroups = items;
        },

        removePriceKey(item, items) {
            this.add(this.priceKeys, item);
            this.selectKeys = items;
        },

        addPriceKey(item, items) {
            this.add(this.selectKeys, item);
            this.priceKeys = items
        },

        removeProduct(item, items) {
            this.add(this.productsList, item);
            this.selectProducts = items;
        },

        addProduct(item, items) {
            this.add(this.selectProducts, item);
            this.productsList = items;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>
